var render = function render(){var _vm=this,_c=_vm._self._c;return _c('carousel-wrapper',{ref:"carousel"},_vm._l((_vm.formattedOptions),function(option,index){return (option.show)?_c('card',{key:index,ref:"card",refInFor:true,attrs:{"option":option,"index":index},on:{"click":function($event){return _vm.handleActionInCard(index)}}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }